import React from "react";
export const DelinkModalIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <circle cx="25" cy="25" r="25" fill="#FDF3F4" />
      <path
        d="M35.48 14.5196C33.4543 12.4935 30.1696 12.4935 28.1439 14.5196L26.0478 16.6154C25.7585 16.9048 25.7585 17.3743 26.0478 17.6637C26.3372 17.9527 26.8067 17.9527 27.0961 17.6637L29.1918 15.5675C30.6387 14.1205 32.9849 14.1205 34.4321 15.5675C35.8794 17.0145 35.879 19.3605 34.4321 20.8082L28.1439 27.0964C26.697 28.5434 24.3512 28.5434 22.9039 27.0964C22.6145 26.807 22.1455 26.807 21.8557 27.0964C21.5663 27.3854 21.5663 27.8549 21.8557 28.1443C23.8817 30.1705 27.1657 30.1705 29.1918 28.1443L35.48 21.8557C37.506 19.8299 37.506 16.5458 35.48 14.5196Z"
        fill="#DC3545"
      />
      <path
        d="M23.9513 32.3365C23.6619 32.0471 23.1928 32.0471 22.9034 32.3365L20.8074 34.4327C19.3601 35.8797 17.0143 35.8797 15.567 34.4327C14.1201 32.9853 14.1201 30.6398 15.567 29.192L21.8552 22.9035C23.3025 21.4565 25.6479 21.4565 27.0956 22.9035C27.3846 23.1929 27.8541 23.1929 28.1434 22.9035C28.4328 22.6141 28.4328 22.145 28.1434 21.8556C26.1174 19.8294 22.833 19.8294 20.8074 21.8556L14.5195 28.1441C12.4935 30.1703 12.4935 33.4545 14.5195 35.4806C16.5456 37.5068 19.8296 37.5068 21.8556 35.4806L23.9517 33.3844C24.241 33.0954 24.241 32.6259 23.9513 32.3365Z"
        fill="#DC3545"
      />
      <rect
        x="18"
        y="15.5547"
        width="1"
        height="22.7853"
        transform="rotate(-33.5963 18 15.5547)"
        fill="#DC3545"
      />
    </svg>
  );
};
